module.exports = __webpack_public_path__ + "media/images/excel-128-70be375024100424d0bf954b27bf2386.png";